import { useCallback, useState } from 'react'

import { apiCall, ApiConfig } from '../config/api'

import { PickingRouteProductDetail } from '../interfaces/PickingRoute/PickingRouteDetails/PickingRouteProductDetail'

const usePickingRouteDetails = () => {
  const [productDetails, setProductDetails] = useState<
    PickingRouteProductDetail[]
  >([])

  const [error, setError] = useState<string | undefined>(undefined)

  const [loading, setLoading] = useState<boolean>(false)

  const getPickingRouteProductDetails = useCallback(async (asnId: number) => {
    setLoading(true)
    apiCall(
      'GET',
      ApiConfig.PickingRouteDetailsApi +
        `/PickingRoutePickerDetails?pickingRouteId=${asnId}`
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error(`No fue posible obtener los registros.`)
        }
        setProductDetails(response.data)
        setError(undefined)
      })
      .catch(({ data: { message } }) => setError(message))
      .finally(() => setLoading(false))
  }, [])

  const getPickingRouteProductDetailsProgress = useCallback(
    async (asnId: number) => {
      setLoading(true)
      apiCall(
        'GET',
        ApiConfig.PickingRouteDetailsApi +
          `/PickingRoutePickerDetails?pickingRouteId=${asnId}&isProgress=true`
      )
        .then((response) => {
          if (response.status !== 200) {
            throw new Error(`No fue posible obtener los registros.`)
          }
          setProductDetails(response.data)
          setError(undefined)
        })
        .catch(({ data: { message } }) => setError(message))
        .finally(() => setLoading(false))
    },
    []
  )

  return {
    loading,
    error,
    getPickingRouteProductDetails,
    getPickingRouteProductDetailsProgress,
    productDetails
  }
}

export default usePickingRouteDetails
